import Vue from 'vue'

const state = {
  baseUri: '/botw/perform/history/'
}
const getters = {
}
const actions = {
  codes: function (_context, [paramData, callback]) { // 성능점검 - 통신설비 점검이력 코드 조회
    paramData = JSON.parse(JSON.stringify(paramData))
    const reqData = {
      spotSeq: paramData.spotSeq
    }
    console.log('PerformHistory-codes', reqData)
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'codes',
      params: reqData
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  search: function (_context, [paramData, callback]) { // 성능점검 - 통신설비 세부설비 조건 별 조회
    paramData = JSON.parse(JSON.stringify(paramData))
    const reqData = {
      spotSeq: paramData.spotSeq,
      checkYear: paramData.searchYear,
      checkCycle: paramData.checkCycle,
      checkTypeCodeId: paramData.checkTypeCodeId,
      upFacilityCodeGroupId: paramData.upFacilityCodeGroupId,
      upFacilityCodeId: paramData.upFacilityCodeId,
      facilityCodeGroupId: paramData.facilityCodeGroupId,
      facilityCodeId: paramData.facilityCodeId,
      childFacilityCodeGroupId: paramData.childFacilityCodeGroupId,
      childFacilityCodeId: paramData.childFacilityCodeId,
      checkStatusCodeId: paramData.checkStatusCodeId,
      rowCount: paramData.rowCount,
      pageNum: paramData.pageNum,
      confirmFlag: paramData.confirmFlag
    }
    console.log('PerformHistory-search', reqData)
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'search',
      params: reqData
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  pdfDown: function (_context, [paramData, callback]) { // 성능점검 - 점검이력 pdfDown
    paramData = JSON.parse(JSON.stringify(paramData))
    const reqData = paramData
    console.log('PerformHistory-pdfDown', reqData)
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'pdfDown',
      params: reqData
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  updateStatus: function (_context, [paramData, callback]) { // 성능점검 - 점검이력 보고상태 변경
    paramData = JSON.parse(JSON.stringify(paramData))
    const reqData = paramData
    console.log('PerformHistory-updateStatus', reqData)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'updateStatus',
      data: reqData
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  detail: function (_context, [paramData, callback]) { // 성능점검 - 세부설비 조건 별 조회
    paramData = JSON.parse(JSON.stringify(paramData))
    const reqData = {
      bundleSeq: paramData.bundleSeq,
      spotSeq: paramData.spotSeq,
      historySeq: paramData.historySeq
    }
    const historySeq = paramData.historySeq
    console.log('PerformHistory-detail', historySeq, reqData)
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'detail',
      params: reqData
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
